var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1477 6.59551L13.1998 5.8624L11.2021 2.42134L12.3384 1.2182C13.2428 0.260599 14.7104 0.260599 15.6148 1.2182L16.2873 1.92325C17.1917 2.88085 17.1917 4.43476 16.2873 5.39236L15.1477 6.59551Z",
    fill: "#ED718B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2242 4.30517L14.1045 5.49077L15.1977 6.64831L16.3141 5.46622C17.2285 4.49809 17.2285 2.92664 16.3141 1.95501L15.6847 1.28855C15.6052 1.20436 15.5224 1.1307 15.4362 1.06055C16.1319 2.03218 16.0591 3.42123 15.2242 4.30517Z",
    fill: "#D5667D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8196 16.4772L3.64639 15.3933L1.87402 12.2995L9.74199 3.96875L13.1343 6.54691L13.6876 8.14291L5.8196 16.4772Z",
    fill: "#D8A030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74346 3.96947L1.875 12.3008L3.50304 14.0246L11.3715 5.69328L9.74346 3.96947Z",
    fill: "#FAC864"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9017 5.19213L3.0332 13.5234L4.66124 15.2472L12.5297 6.91593L10.9017 5.19213Z",
    fill: "#FFE27A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7438 8.20113L9.68886 3.90771C9.50996 3.71829 9.50996 3.41663 9.68886 3.22721L10.5071 2.36081C10.686 2.1714 10.9709 2.1714 11.1498 2.36081L15.2047 6.65424C15.3836 6.84365 15.3836 7.14532 15.2047 7.33473L14.3864 8.20113C14.2076 8.39055 13.9193 8.39055 13.7438 8.20113Z",
    fill: "#D1D5D7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81874 16.4769L3.77804 17.2626L0.776617 18.4202C0.511591 18.5219 0.249878 18.4096 0.110739 18.1992C0.0080412 18.0483 -0.0317127 17.8449 0.0411695 17.6415L1.1344 14.4635L1.87648 12.3027L5.81874 16.4769Z",
    fill: "#FFE0D0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65976 15.248L5.81593 16.4722L3.77523 17.258L0.77381 18.4155C0.581666 18.4892 0.389522 18.4506 0.24707 18.3418L4.65976 15.248Z",
    fill: "#F8C2AB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77519 17.262L0.773768 18.4196C0.488865 18.5283 0.210588 18.388 0.0780746 18.153C-0.00143331 18.0092 -0.0279359 17.8268 0.0350078 17.6409L1.12824 14.4629L3.77519 17.262Z",
    fill: "#3E3D4C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4385 6.82033L13.7338 8.19184C13.9127 8.38126 14.2042 8.38126 14.3831 8.19184L15.1947 7.33246C15.3736 7.14304 15.3736 6.83436 15.1947 6.64495L13.8994 5.27344C14.0783 5.46285 14.0783 5.77153 13.8994 5.96095L13.0878 6.82033C12.9089 7.00975 12.6174 7.00975 12.4385 6.82033Z",
    fill: "#AEB1B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00974 16.4492L3.8015 17.2876L0.800079 18.4451C0.624499 18.5117 0.455545 18.4872 0.316406 18.3995L3.00974 16.4492Z",
    fill: "#2C3033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.af4464427fdd566d4e8d32ec1119a927.svg";
export { ForwardRef as ReactComponent };